export const matchesSidebarPath = (pathname, path) =>
   Boolean(path && (pathname === path || pathname.startsWith(path + "/")));

export const sidebarItemIsActive = (item, pathname) => {
   const path = item.isDirectLink ? item.url.replace(/\/(view|list)$/, "") : item.url;
   if (matchesSidebarPath(pathname, path)) return true;
   return (item.dropdownList || []).some((child) =>
      matchesSidebarPath(pathname, child.path || item.url + child.url),
   );
};
